export default function getN8NChatStore(sharedKey) {
    if (!sharedKey) return null;
    const w = typeof window !== 'undefined' ? window : {};
    if (!w.__n8nChatStores) w.__n8nChatStores = {};
    if (!w.__n8nChatStores[sharedKey]) {
        w.__n8nChatStores[sharedKey] = {
            isOpen: false,
            isMinimized: false,
            messages: [],
            sessionId: null,
            activeInstanceId: null,
            behaviourSent: false,
        };
    }
    return w.__n8nChatStores[sharedKey];
}
